export default {"src":"/_next/static/media/plane.4e295ffe.gif","height":750,"width":1500};